/**
 * Переводит радианы в градусы со сдвигом на 180 градусов,
 * чтобы нулевой градус был слева (на 9 часов)
 *
 * @param {number} degrees
 * @returns {number}
 */
const toRad = (degrees) => (Math.PI / 180) * degrees + Math.PI;

const useDonutDiagram = (canvas, userConfig = {}) => {
  const defaultConfig = {
    lineWidth: 24,
    colors: ['#1A88F3', '#2AB764', '#f9b834'],
    arcsOffset: 5.5,
  };

  const config = {
    ...defaultConfig,
    ...userConfig,
  };

  const context = canvas.getContext('2d');

  const centerCoordinate = canvas.width / 2;
  const radius = centerCoordinate - config.lineWidth / 2;

  context.lineWidth = config.lineWidth;

  const drawBaseArc = (startAngle, endAngle, color) => {
    context.strokeStyle = color;

    context.beginPath();
    context.arc(
      centerCoordinate,
      centerCoordinate,
      radius,
      toRad(startAngle),
      toRad(endAngle),
    );
    context.stroke();
  };

  const getEdgeCoordinates = (angle) => {
    const angleInRadians = toRad(angle);

    return {
      x: radius * Math.cos(angleInRadians) + centerCoordinate,
      y: radius * Math.sin(angleInRadians) + centerCoordinate,
    };
  };

  const drawArcEdges = (startAngle, endAngle, color) => {
    const startAngleCoordinates = getEdgeCoordinates(startAngle);
    const endAngleCoordinates = getEdgeCoordinates(endAngle);

    context.fillStyle = color;
    [startAngleCoordinates, endAngleCoordinates].forEach(({ x, y }) => {
      context.beginPath();
      context.arc(
        x,
        y,
        config.lineWidth / 2,
        0,
        Math.PI * 2,
      );
      context.fill();
    });
  };

  const drawArc = (startAngle, endAngle, color) => {
    let startAngleWithOffset = startAngle + config.arcsOffset;
    let endAngleWithOffset = endAngle - config.arcsOffset;

    if (startAngleWithOffset > endAngleWithOffset) {
      const angle = startAngle + (endAngle - startAngle) / 2;
      startAngleWithOffset = angle;
      endAngleWithOffset = angle;
    }

    drawBaseArc(
      startAngleWithOffset,
      endAngleWithOffset,
      color,
    );

    drawArcEdges(
      startAngleWithOffset,
      endAngleWithOffset,
      color,
    );
  };

  const clear = () => {
    context.clearRect(0, 0, canvas.width, canvas.height);
  };

  const render = (values) => {
    clear();

    const total = values.reduce((acc, item) => acc + item);
    const fractions = total === 0
      ? Array(values.length).fill(1 / values.length)
      : values.map((item) => item / total);

    let previousEndAngle = 0;

    fractions.forEach((value, index) => {
      if (value === 0) {
        return;
      }

      const startAngle = previousEndAngle;
      const endAngle = startAngle + 360 * value;

      previousEndAngle = endAngle;

      const color = config.colors[index % config.colors.length];

      const draw = value === 1
        ? drawBaseArc
        : drawArc;

      draw(
        startAngle,
        endAngle,
        color,
      );
    });
  };

  return { render };
};

export default useDonutDiagram;
